import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: 'tooltip.component.html',
  styleUrl: 'tooltip.component.scss'
})
export class TooltipComponent {
  text = input<string>('');
  size = input<'sm' | 'md' | 'lg'>('md');
  color = input<'primary' | 'info' | 'success' | 'warning' | 'danger'>('primary');
}
